import React, { useEffect, useState } from "react";
import "./Explore_The_Categories.css";
import Common_Title from "../../../common_components/common_title/Common_Title";
import { useSelector } from "react-redux";

const MattressLayers = () => {
  const product_layers = useSelector(
    (state) => state.product?.product?.Product_Layers,
  );
  const layer_img = useSelector((state) => state.product?.product?.layer_img);

  // console.log(product_layers.length(), "layer data")

  console.log(product_layers, "layer of product");

  // const [data, setData] = useState({
  // title: "Gold Infused Bio-Ceramic Fabric",
  // descn:
  //   "This special jacquard fabric has a 3D design that helps in moisture-wicking and airflow.",
  // active: 1,
  // });

  const [data, setData] = useState({
    name: "",
    description: "",
    active: null,
  });

  useEffect(() => {
    if (product_layers && product_layers.length > 0) {
      setData({
        name: product_layers[0].name,
        description: product_layers[0].description,
        active: product_layers[0].sr_no,
      });
    }
  }, [product_layers]);

  const layersWithSrNo = product_layers?.map((item, index) => ({
    ...item,
    sr_no: index + 1,
  })) || [];

  // const leftPoints = layersWithSrNo.filter((x) => x.sr_no % 2 === 0);
  // const rightPoints = layersWithSrNo.filter((x) => x.sr_no % 2 !== 0);

  // const handleClick = (num) => {
  //   const content = {
  //     1: {
  //       title: "Gold Infused Bio-Ceramic Fabric",
  //       descn: "Breathable top fabric with airflow support.",
  //     },
  //     2: {
  //       title: "Comfort Foam",
  //       descn: "Provides soft cushioning.",
  //     },
  //     3: {
  //       title: "Support Foam",
  //       descn: "Ensures proper body support.",
  //     },
  //     4: {
  //       title: "Cooling Gel",
  //       descn: "Regulates temperature.",
  //     },
  //     5: {
  //       title: "Transition Layer",
  //       descn: "Balances softness and firmness.",
  //     },
  //     6: {
  //       title: "Pocket Springs",
  //       descn: "Improves motion isolation.",
  //     },
  //     7: {
  //       title: "Base Foam",
  //       descn: "Strong foundation layer.",
  //     },
  //     8: {
  //       title: "Edge Support",
  //       descn: "Reinforces edges.",
  //     },
  //     9: {
  //       title: "Bottom Layer",
  //       descn: "Adds durability.",
  //     },
  //     10: {
  //       title: "Base Support",
  //       descn: "Final structural support.",
  //     },
  //   };

  //   setData({
  //     ...content[num],
  //     active: num,
  //   });
  // };

  const handleClick = (sr_no) => {
    const selected = layersWithSrNo.find((x) => x.sr_no === sr_no);

    if (selected) {
      setData({
        name: selected.name,
        description: selected.description,
        active: sr_no,
      });
    }
  };

  // console.log("leftPoints:", leftPoints);

  if (!layersWithSrNo.length) {
    return null; // or return <></>;
  }

  return (
    <section className="explore-section">
      <div className="container">
        <div className="heading">
          <Common_Title
            title={
              <>
                Explore The <span className="highlight">Layers</span> of Your
                Mattress
              </>
            }
          />
        </div>

        <div className="explore_cards">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-12 order-2 order-md-1">
              <div className="info-box">
                <div className="mb-4">

                  {/* <h3 className="highlight subtext">Layer 1 :- </h3>
                  <h3 className="subtext">{data.name}</h3>
                  <p className="text">
                    {data.description?.replace(/<[^>]+>/g, "")}
                  </p> */}
                  {product_layers?.map((item,index) => (
                    <div key={item.sr_no} className="layer-block">
                      <h3 className="highlight subtext">Layer {index+1} :</h3>
                      <h3 className="subtext">{item.name}</h3>
                      <p className="text">
                        {item.description?.replace(/<[^>]+>/g, "")}
                      </p>
                      <hr />
                    </div>
                  ))}

                  <hr></hr>
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-6 col-12 order-1 order-md-2">
              <div className="image_box">
                <div className="image-wrapper">
                  {/* <img
                    src="/assets/images/product_description/Mattress-Layers.png"
                    alt="Mattress Layers"
                    className="mattress_img"
                  /> */}
                  <img
                    src={process.env.REACT_APP_IMG_URL + layer_img}
                    alt="Mattress Layers"
                    className="mattress_img"
                  />

                  {/* <div className="points_wrapper">

                    <div className="points left_points">
                      {leftPoints?.map((item) => (
                        <div
                          key={item.sr_no}
                          className={`point ${data.active === item.sr_no ? "active" : ""}`}
                          onClick={() => handleClick(item.sr_no)}
                        >
                          {item.sr_no}
                        </div>
                      ))}
                    </div>

                    <div className="points right_points">
                      {rightPoints?.map((item) => (
                        <div
                          key={item.sr_no}
                          className={`point ${data.active === item.sr_no ? "active" : ""}`}
                          onClick={() => handleClick(item.sr_no)}
                        >
                          {item.sr_no}
                        </div>
                      ))}
                    </div>

                  </div> */}
                  {/* 
           <div className="points_wrapper">
                  <div className="points left_points">
                    {[2, 4, 6, 8,10].map((num) => (
                      <div
                        key={num}
                        className={`point ${data.active === num ? "active" : ""}`}
                        onClick={() => handleClick(num)}
                      >
                        {num}
                      </div>
                    ))}
                  </div>

                  <div className="points right_points">
                    {[1, 3, 5, 7, 9].map((num) => (
                      <div
                        key={num}
                        className={`point ${data.active === num ? "active" : ""}`}
                        onClick={() => handleClick(num)}
                      >
                        {num}
                      </div>
                    ))}
                  </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MattressLayers;
